import clsx from "clsx";
import { useState } from "react";

import { Button } from "@src/components/Button";

import "./style.less";
import type { PortalMobileProps } from "./types";

export function PortalMobile({ links }: PortalMobileProps) {
  const [radio, setRadio] = useState("");
  const names = Object.keys(links);

  if (names.length === 0) {
    return <></>;
  }

  return (
    <div className="PortalMobile-component card">
      {names.map((name) => (
        <div key={name} className="radio">
          <Button
            onClick={() => {
              setRadio(radio === name ? "" : name);
            }}
            className={clsx({
              active: radio === name,
              inactive: radio !== name,
            })}
          >
            {name}
          </Button>
          {radio === name && (
            <div className="links">
              <a href={links[name].recommended} target="_blank">
                Recomendado Full
              </a>
              <a href={links[name].alternative} target="_blank">
                Alternativo Full
              </a>
              <a href={links[name].recommended_lite} target="_blank">
                Recomendado Lite
              </a>
              <a href={links[name].alternative_lite} target="_blank">
                Alternativo Lite
              </a>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
